import React, { useState } from 'react';
import moment from 'moment';
import polygon from '../../images/icons/polygon.svg';
import fileUpload from '../../images/icons/fileUpload.svg';
import deleteIcon from '../../images/icons/delete.svg';

const DetailRow = ({ label, value }) => (
  <div className="mb-2">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-sm font-bold text-gray-800">{value ?? '—'}</div>
  </div>
);

const AdvanceRequestDetailView = ({
  advancePurchaseOrder = [],
  onDeleteAttachment,
  showDeleteButton = false,
  style = {}
}) => {
  const [sectionExpanded, setSectionExpanded] = useState(true);
  const formatDate = (val) => {
    if (!val) return '—';
    const m = moment(val);
    return m.isValid() ? m.format('DD-MM-YYYY') : val;
  };

  if (!Array.isArray(advancePurchaseOrder) || advancePurchaseOrder.length === 0) {
    return null;
  }

  return (
    <div className="my-4" style={style}>
      <div
        onClick={() => setSectionExpanded(!sectionExpanded)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setSectionExpanded(!sectionExpanded); }}
        aria-expanded={sectionExpanded}
        className="flex flex-row place-content-between mb-4  mt-4 bg-secondary-500 p-1 px-2.5 rounded-md  cursor-pointer"
      >
        <div className="text-base font-muli text-white-light font-bold">Advance Request</div>
        <img
          src={polygon}
          alt="expand/collapse"
          className={`${!sectionExpanded ? 'transform -rotate-90' : ''} w-6`}
        />
      </div>

      {sectionExpanded && (
        <div className="space-y-6">
          {advancePurchaseOrder.map((item, index) => {
            const attachments = item?.arqAttachments ?? item?.advanceAttachments ?? [];
            const attList = Array.isArray(attachments) ? attachments : [];
            return (
              <div
                key={item?.id || index}
                className="p-4 rounded border"
                style={{ border: '2px solid rgb(238, 238, 238)', borderRadius: '10px', backgroundColor: 'rgba(241, 241, 241, 1)' }}
              >
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                  <DetailRow label="Advance Request No" value={item?.arqNumber} />
                  <DetailRow label="SAP Adv. Request No." value={item?.sapArqNumber} />
                  <DetailRow label="Status" value={item?.status} />
                  <DetailRow label="Proforma Invoice Date" value={formatDate(item?.proformaInvoiceDate)} />
                </div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                  <DetailRow
                    label="Payment Terms"
                    value={item?.paymentTermsDesc}
                  />
                  <DetailRow label="Advance Amount" value={item?.advanceAmount != null ? item.advanceAmount : '—'} />
                  <DetailRow label="Proforma Invoice No" value={item?.proformaInvoiceNo} />
                </div>

                {attList.length > 0 && (
                  <div className="mb-4">
                    <div className="text-sm text-gray-500 mb-2">Attachments</div>
                    <div className="flex flex-wrap gap-3 items-center">
                      {attList.map((att) => {
                        const openUrl = att?.preSignedUrl ?? att?.preSignedURL;
                        return (
                        <div
                          key={att?.id ?? att?.attachmentId ?? att?.attachmentName ?? att?.docId}
                          className="flex items-center gap-3 p-2 bg-white rounded shadow-sm border border-gray-100"
                          style={{ minWidth: 200 }}
                        >
                          {openUrl ? (
                            <a
                              href={openUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex-shrink-0 w-10 h-10 rounded overflow-hidden flex items-center justify-center cursor-pointer no-underline"
                              style={{ backgroundColor: 'rgba(224, 242, 254, 1)' }}
                              title="Open in new tab"
                            >
                              <img src={fileUpload} alt="" className="w-8 h-8" />
                            </a>
                          ) : (
                            <div
                              className="flex-shrink-0 w-10 h-10 rounded overflow-hidden flex items-center justify-center"
                              style={{ backgroundColor: 'rgba(224, 242, 254, 1)' }}
                            >
                              <img src={fileUpload} alt="" className="w-8 h-8" />
                            </div>
                          )}
                          {openUrl ? (
                            <a
                              href={openUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex-1 min-w-0 text-sm font-muli text-gray-800 truncate cursor-pointer hover:underline no-underline text-inherit"
                              title={att?.attachmentName ?? att?.name ?? att?.fileName ?? 'Open in new tab'}
                            >
                              {(() => {
                                const name = att?.attachmentName ?? att?.name ?? att?.fileName ?? '—';
                                return name.length > 20 ? `${name.slice(0, 20)}...` : name;
                              })()}
                            </a>
                          ) : (
                            <div className="flex-1 min-w-0 text-sm font-muli text-gray-800 truncate" title={att?.attachmentName ?? att?.name ?? att?.fileName ?? ''}>
                              {(() => {
                                const name = att?.attachmentName ?? att?.name ?? att?.fileName ?? '—';
                                return name.length > 20 ? `${name.slice(0, 20)}...` : name;
                              })()}
                            </div>
                          )}
                          {showDeleteButton && (
                            <button
                              type="button"
                              className="flex-shrink-0 p-1.5 text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                              onClick={() => { if (typeof onDeleteAttachment === 'function') onDeleteAttachment(item, att); }}
                              disabled={typeof onDeleteAttachment !== 'function'}
                              aria-label="Remove attachment"
                            >
                              <img src={deleteIcon} alt="" className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {(item?.remarks != null && item.remarks !== '') && (
                  <div>
                    <div className="text-sm text-gray-500 mb-1">Remarks</div>
                    <div className="text-sm text-gray-800 ">
                      {item.remarks}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdvanceRequestDetailView;
